
const codigoApp = process.env.REACT_APP_CODIGO_APLICACION;
const backOffice_programa = process.env.REACT_APP_BACKOFFICE_PROGRAMA;
const codigoIntitucion = process.env.REACT_APP_CODIGO_INSTITUCION;
const extensionArchivo = process.env.REACT_APP_EXTENSION_ARCHIVO;
const tamanoArchivo = process.env.REACT_APP_MAXIMO_SIZE_ARCHIVO;
const paginaMantenimiento = process.env.REACT_APP_PAGINA_EN_MANTENIMIENTO;

const key_public_pem_encripted_login = process.env.REACT_APP_KEY_PUBLIC_PEM_ENCRYPT;

const COURSERA_GMODALIDAD = process.env.REACT_APP_COURSERA_GMODALIDAD;

const KEY_SAFETY_PAY =  process.env.REACT_APP_KEY_SAFETY_PAY;
const KEY_SOLES_PAYMENT =  process.env.REACT_APP_KEY_SOLES_PAYMENT;
const KEY_DOLARES_PAYMENT = process.env.REACT_APP_KEY_DOLARES_PAYMENT;

const timeOutCierreSesions = process.env.REACT_APP_TIMEOUT_CIERRESESION;

const minValidacionSeguridad = process.env.REACT_APP_MIN_VALIDACION_SEGURIDAD;

const segValidacionSeguridad = process.env.REACT_APP_SEG_VALIDACION_SEGURIDAD;

const sincruce = process.env.REACT_APP_SINCRUCE_CPROGRAMA;

const encuesta_caracters = process.env.REACT_APP_ENCUESTA_CARACTERS;

const apiRenuevaTokenGlo = process.env.REACT_APP_API_RENOVACION_TOKEN_URL;

const REACT_APP_REFRESH_TOKEN = process.env.REACT_APP_REFRESH_TOKEN;

const REACT_APP_CLIENT_ID = process.env.REACT_APP_CLIENT_ID; 
const REACT_APP_CLIENT_SECRET= process.env.REACT_APP_CLIENT_SECRET;

const apiLogin = process.env.REACT_APP_API_LOGIN_URL;
const apiDatosEstudiante = process.env.REACT_APP_API_DATOS_ESTUDIANTE_URL;
const apiDatosSoporte = process.env.REACT_APP_API_DATOS_SOPORTE_URL;
const apiAsignatura = process.env.REACT_APP_API_LISTA_ASIGNATURAS_URL;
const apiCierreMatricula = process.env.REACT_APP_API_INSERT_CIERRE_MATRICULA;
const apiCierreMatriculaControlado = process.env.REACT_APP_API_INSERT_CIERRE_MATRICULA_CONTROLADO;
const apiGenerarProcesoEstudiante= process.env.REACT_APP_API_GENERAR_PROCESO_ESTUDIANTE;
const apiValidarErrorProceso= process.env.REACT_APP_API_VALIDAD_ERROR_PROCESO;


const apiGrupos = process.env.REACT_APP_API_LISTA_GRUPOS_URL;
const apiRequisitoMat = process.env.REACT_APP_API_LISTA_REQUISITOS_MATRICULA_URL;
const apiRequisitosYDocumentos = process.env.REACT_APP_API_LISTA_REQUISITOS_Y_DOCUMENTOS_URL;
const apiProgramas = process.env.REACT_APP_API_LISTA_PROGRAMAS_URL;
const apiPeriodos = process.env.REACT_APP_API_LISTA_PERIODOS_URL;
const apiImagenLogin = process.env.REACT_APP_API_IMAGENES_LOGIN_URL;
const apiIdioma = process.env.REACT_APP_API_LISTA_IDIOMAS_URL;
const apiListaEtiquetas = process.env.REACT_APP_API_LISTA_ETIQUETAS_URL;
const apiDocumentos = process.env.REACT_APP_API_LISTA_DOCUMENTOS;
const apiCrearTokenResetPassword = process.env.REACT_APP_API_CREATE_TOKEN_PASSWORD;
const apiValidarTokenResetPassword = process.env.REACT_APP_API_VALIDAR_TOKEN_PASSWORD;

//Segmentacion por franjas
const apiFranjaAlumnoPeriodo = process.env.REACT_APP_API_LISTA_FRANJA_ALUMNOPERIODO;
const apiAsignaturaFranja = process.env.REACT_APP_API_LISTA_ASIGNATURAS_FRANJA;
const apiGruposFranja = process.env.REACT_APP_API_LISTA_GRUPOS_FRANJA;
const apiAsignaturaMasivaFranja = process.env.REACT_APP_API_ASIGNATURA_MASIVA_FRANJA;

// PROCESO DE MATRICULA
const apiUpdatePaso = process.env.REACT_APP_API_UPDATE_PASO;
const apiListaDatosPersonales = process.env.REACT_APP_API_LISTA_DATOS_PERSONALES;
const apiReglamentoEstudios = process.env.REACT_APP_API_REGLAMENTOS_ESTUDIOS;
const apiInserarReglamentoEstudios = process.env.REACT_APP_API_INSERTAR_REGLAMENTOS_ESTUDIOS_ACEPTADOS;
const apiListaSeguroAccidentes = process.env.REACT_APP_API_LISTA_SEGURO_ACCIDENTES;
const apiValidarSeguroUpch = process.env.REACT_APP_API_VALIDAR_SEGURO_UPCH;
const apiListaEmpresasSeguro = process.env.REACT_APP_API_LISTA_EMPRESAS_SEGURO;
const apiInsertarDatosPersonales = process.env.REACT_APP_API_UPDATE_DATOS_PERSONALES;
const apiInsertarSegurosEstudiante = process.env.REACT_APP_API_UPDATE_SEGURO_ESTUDIANTE;
const apiListaAsignaturasEstudiante = process.env.REACT_APP_API_LISTA_ASIGNATURAS_ESTUDIANTE;
const apiAsignarAsignaturasEstudiante = process.env.REACT_APP_API_ASIGNAR_ASIGNATURAS_ESTUDIANTE;

const apiPasarelaSafetyPay = process.env.REACT_APP_API_PASARELA_SAFETYPAY;
 

const apiResumenPago = process.env.REACT_APP_API_RESUMEN_PAGO; 
const apiCuotasPago = process.env.REACT_APP_API_CUOTAS_PAGOS;
const apiPagoCuotasPendientes = process.env.REACT_APP_API_PAGO_CUOTAS_PENDIENTES; 
const apiValidacionEstadoPagoMatricula = process.env.REACT_APP_API_VALIDACION_ESTADO_PAGO_MATRICULA;
const apiValidacionEstadoPago = process.env.REACT_APP_API_VALIDACION_ESTADO_PAGO;
const apiUpdateDatosPago = process.env.REACT_APP_API_UPDATE_DATOS_PAGO;

const segExonerado = process.env.REACT_APP_SEG_EXONERADO;

const apiListadoBancos = process.env.REACT_APP_API_LISTADO_BANCOS;

const apiCreaModalidad = process.env.REACT_APP_API_CREAMODALIDAD;
const apiGeneracionCuenta = process.env.REACT_APP_API_GENERACION_CUENTA;

const apiModalidadPagos = process.env.REACT_APP_API_MODALIDAD_PAGO;


const ambiente = process.env.REACT_APP_AMBIENTE;
const cGclasificacion = process.env.REACT_APP_GCLASIFICACION;
const cGmatricula = process.env.REACT_APP_GMATRICULA;
 

 
const API_LIST_FILTRO = process.env.REACT_APP_API_LIST_FILTRO_URL;
const API_LISTAUTORIZACIONES_PAG = process.env.REACT_APP_API_LISTAUTORIZACIONES_PAG_URL;
const API_CRUD_AUTORIZACIONES = process.env.REACT_APP_API_CRUD_AUTORIZACIONES_URL;

const keyPassLogin = process.env.REACT_APP_LOGIN_KEY;

 

const API_CONSTACIAS_HABILITADAS = process.env.REACT_APP_API_CONSTACIAS_HABILITADAS;
const API_DATOS_CONSTACIA = process.env.REACT_APP_API_DATOS_CONSTACIA;
const API_UPLOADFILE = process.env.REACT_APP_API_UPLOADFILE;
const API_DATOS_HORARIO = process.env.REACT_APP_API_DATOS_HORARIO;
const API_CRONOGRAMA_PAGO = process.env.REACT_APP_API_CRONOGRAMA_PAGO;
const API_RUTA_CONSTANCIA = process.env.REACT_APP_API_RUTA_CONSTANCIA;

//ENCUESTA
const API_LISTAS_HABILITADAS = process.env.REACT_APP_API_LISTAS_HABILITADAS;
const API_LISTAS_PREGUNTAS = process.env.REACT_APP_API_LISTAS_PREGUNTAS;
const API_RESPUESTAS = process.env.REACT_APP_API_RESPUESTAS;

const API_SESIONESHABILITADAS = process.env.REACT_APP_API_SESIONESHABILITADAS;

const API_SEGURO_DATOS = process.env.REACT_APP_API_SEGURO_DATOS;
const API_SEGURO_PRELIQUIDACION = process.env.REACT_APP_API_SEGURO_PRELIQUIDACION;
const API_REGISTRO_PAGOEXITO = process.env.REACT_APP_API_REGISTRO_PAGOEXITO;
const API_REGISTRO_RESPUESTAPASARELA = process.env.REACT_APP_API_REGISTRO_RESPUESTAPASARELA;

export const API_PASARELA_PAGOS_REGISTRAR = process.env.REACT_APP_API_PASARELA_PAGOS_REGISTRAR;
export const API_PASARELA_PAGOS_RESULTADO = process.env.REACT_APP_API_PASARELA_PAGOS_RESULTADO;

const loginCaptchaLong = process.env.REACT_APP_LOGIN_CAPTCHA_LONG;
const loginCaptchaBackgroundColor = process.env.REACT_APP_LOGIN_CAPTCHA_BACKGROUND_COLOR;
const loginCaptchaFontoColor = process.env.REACT_APP_LOGIN_CAPTCHA_FONT_COLOR;

const pasarelaPayment = 1;
const pasarelaSafetyPay = 2;
const firma_constacia_matricula =  process.env.REACT_APP_IMAGEN_FIRMA_CONSTANCIA;
const apiFotoEstudiante = process.env.REACT_APP_API_FOTO_ESTUDIANTE_URL;
const apiDesmatricular = process.env.REACT_APP_API_DESMATRICULAR;

export {
  pasarelaPayment,
  pasarelaSafetyPay,
  apiRenuevaTokenGlo,
  apiLogin,
  apiDatosEstudiante,
  apiDatosSoporte,
  apiAsignatura,
  apiGrupos,
  apiRequisitoMat,
  apiRequisitosYDocumentos,
  apiProgramas,
  apiPeriodos,
  apiImagenLogin,
  apiIdioma,
  apiListaEtiquetas,
  apiDocumentos,
  apiListaDatosPersonales,
  apiReglamentoEstudios,
  apiInserarReglamentoEstudios,
  apiListaSeguroAccidentes,
  apiListaEmpresasSeguro,
  apiUpdatePaso,
  apiInsertarDatosPersonales,
  apiInsertarSegurosEstudiante,
  codigoApp,
  codigoIntitucion,
  apiAsignarAsignaturasEstudiante,
  apiListaAsignaturasEstudiante,
  apiResumenPago,
  // apiPasarelaPago,
  // apiPasarelaPagoCrearToken,
  apiCuotasPago,
  keyPassLogin,
  segExonerado,
  apiCierreMatricula,
  apiCierreMatriculaControlado,
  apiGenerarProcesoEstudiante,
  apiValidarErrorProceso,
  apiListadoBancos,
  extensionArchivo,
  tamanoArchivo,
  apiGeneracionCuenta,
  apiCrearTokenResetPassword,
  apiValidarTokenResetPassword,
  apiCreaModalidad,
  apiModalidadPagos,
  apiPagoCuotasPendientes,
  apiValidacionEstadoPago,
  apiUpdateDatosPago,
  // urlTiendaUPCH,
  // tokenUpch,
  timeOutCierreSesions,
  minValidacionSeguridad,
  segValidacionSeguridad,
  ambiente,
  cGclasificacion,
  cGmatricula,
  apiValidarSeguroUpch,
  API_LIST_FILTRO,
  API_LISTAUTORIZACIONES_PAG,
  API_CRUD_AUTORIZACIONES,
  backOffice_programa,
  paginaMantenimiento,
  sincruce,
  apiValidacionEstadoPagoMatricula,
  API_CONSTACIAS_HABILITADAS,
  API_DATOS_CONSTACIA,
  API_DATOS_HORARIO,
  API_CRONOGRAMA_PAGO,
  API_RUTA_CONSTANCIA,
  API_LISTAS_HABILITADAS,
  API_LISTAS_PREGUNTAS,
  API_RESPUESTAS,
  API_SEGURO_DATOS,
  API_SEGURO_PRELIQUIDACION,
  API_REGISTRO_PAGOEXITO,
  API_REGISTRO_RESPUESTAPASARELA,
  API_SESIONESHABILITADAS,
  API_UPLOADFILE,
  loginCaptchaLong,
  loginCaptchaBackgroundColor,
  loginCaptchaFontoColor,
  encuesta_caracters,
  apiPasarelaSafetyPay,
  KEY_SAFETY_PAY,
  KEY_SOLES_PAYMENT,
  KEY_DOLARES_PAYMENT,
  COURSERA_GMODALIDAD,
  key_public_pem_encripted_login,
  REACT_APP_CLIENT_ID,
  REACT_APP_CLIENT_SECRET,
  REACT_APP_REFRESH_TOKEN,
  apiFranjaAlumnoPeriodo,
  apiAsignaturaFranja,
  apiGruposFranja,
  apiFotoEstudiante,
  apiAsignaturaMasivaFranja,
  firma_constacia_matricula,
  apiDesmatricular
};
